const provinceAliases = {
  alberta: 'Alberta',
  ab: 'Alberta',
  'british columbia': 'British Columbia',
  'colombie britannique': 'British Columbia',
  bc: 'British Columbia',
  manitoba: 'Manitoba',
  mb: 'Manitoba',
  'new brunswick': 'New Brunswick',
  'nouveau brunswick': 'New Brunswick',
  nb: 'New Brunswick',
  'newfoundland and labrador': 'Newfoundland and Labrador',
  'terre neuve et labrador': 'Newfoundland and Labrador',
  nl: 'Newfoundland and Labrador',
  'northwest territories': 'Northwest Territories',
  'territoires du nord ouest': 'Northwest Territories',
  nt: 'Northwest Territories',
  'nova scotia': 'Nova Scotia',
  'nouvelle ecosse': 'Nova Scotia',
  ns: 'Nova Scotia',
  nunavut: 'Nunavut',
  nu: 'Nunavut',
  ontario: 'Ontario',
  on: 'Ontario',
  'prince edward island': 'Prince Edward Island',
  'ile du prince edouard': 'Prince Edward Island',
  pei: 'Prince Edward Island',
  pe: 'Prince Edward Island',
  quebec: 'Quebec',
  qc: 'Quebec',
  saskatchewan: 'Saskatchewan',
  sk: 'Saskatchewan',
  yukon: 'Yukon',
  yt: 'Yukon',
};

function normalize(value) {
  return (value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
}

// English name of the province or territory a code or an English/French name refers to, else null.
export function canadianProvinceName(value) {
  return provinceAliases[normalize(value)] || null;
}

export function isCanadianProvinceReference(delivery) {
  if (
    !delivery ||
    !delivery.region ||
    delivery.streetAddress ||
    delivery.locality ||
    delivery.area ||
    delivery.postalCode
  ) {
    return false;
  }
  const province = canadianProvinceName(delivery.region);
  if (!province || (delivery.countryName && !['canada', 'ca', 'can'].includes(normalize(delivery.countryName)))) {
    return false;
  }
  if (!delivery.raw) return true;
  const raw = normalize(delivery.raw)
    .replace(/(?: canada| ca| can)$/, '')
    .trim();
  return canadianProvinceName(raw) === province;
}
